import React from 'react';
import { Provider } from './models/Context'
import AppRouter from './AppRouter'
import InstallPrompt from './components/InstallPrompt'
import { Toaster } from 'react-hot-toast'
import './App.scss';

function App() {
  return (
    <div className="text-gray h-full">
      <Provider>
        <AppRouter/>
        <InstallPrompt/>
        <Toaster
          position="top-center"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#6298a5',
              color: '#fff',
            },
          }}
        />
      </Provider>
    </div>
  )
}

export default App
